import React, { Fragment, useCallback, useEffect, useState } from 'react';
import _ from "underscore";
import InputMask from 'react-input-mask';
import TextField from "@material-ui/core/TextField";
import { Select, MenuItem, Grid } from "@material-ui/core";

const FeeType = props => {

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const feeTypes = [
    { type: "OTHER", name: "Other", editName: true },
    { type: "AFEE", name: "Airport Fee", editName: false },
    { type: "TRUK", name: "Truck Delivery Fee", editName: false },
  ]

  const getFeeName = (useCallback(type => {
  
    const feeType = _.findWhere(feeTypes, { type });
    if (feeType) { return feeType.name }
    return "";
  },[feeTypes]));
  const getCanEditName = (useCallback(type => {
    const feeType = _.findWhere(feeTypes, { type });
    if (feeType) { return feeType.editName }
    return false;
  },[feeTypes]));

  const [state, setState] = useState({    
    type: null,
    name: null,
    defaultType: props.defaultType,
    canEditName: false,
  });

  useEffect (()=> {
    let type = props.type;
    let name = props.name;
    if (!type) {
      if (props.defaultType) {
        type = props.defaultType;
      } else {
        type = "OTHER";
      }
      name = getFeeName(type);
    }
    if (state.type !== type) {
      setState({...state, type, name, canEditName: getCanEditName(type)});
      props.onChange({type, name });
    }
  },[props, state.type, state, getFeeName, getCanEditName])

//  console.log(state);

  const handleNameChange = event => {
    setState({...state, name: event.target.value});
    props.onChange({type: state.type, name: event.target.value});
  };

  const handleTypeChange = event => {
    setState({
      ...state,
      type: event.target.value,
      name: getFeeName(event.target.value),
      canEditName: getCanEditName(event.target.value),
    });
    props.onChange({type: event.target.value, name: getFeeName(event.target.value)});
  };

  const formatChars={ "a": "."};
  const mask="a".repeat(50);

  return (
      <div>
        <div style={{display: "inline-block", width: "80px", marginTop: (state.canEditName?-1:0)}}>
          <Select
              style={{...props.typeStyle}}
              labelId="type"
              id="type"
              value={state.type}
              onChange={handleTypeChange}
              renderValue={()=>state.type}
            >
              {feeTypes.map((feeType) => {
                return (
                  <MenuItem key={feeType.type} value={feeType.type}>{`${feeType.type} ${feeType.name}`}</MenuItem>
                );
              })
              }
            </Select>      
        </div> 
        <div style={{display: "inline-block", width: "Calc(100% - 80px)"}}>
          {state.canEditName ?
            <InputMask value={state.name}
              mask={mask}
              alwaysShowMask={false}
              maskChar={''}
              formatChars={formatChars}
              onChange={handleNameChange}
            >
              {() => <TextField
                className={props.className}
                variant={props.variant || 'standard'}
                label={props.label || ""}
                required={props.required || false}
                inputProps={{ style: { paddingBottom: 4 }, ...props.inputProps }}
                id={props.id}
                style={{...props.style }} />}
            </InputMask>
            : <div style={{padding:"4px 0px"}}>{state.name}</div>}
        </div>
      </div>
  )
};

export default FeeType;